<template>
  <div :key="key" class="dashboard-chart">
    <h4>Confirmación Propuestas</h4>
    <vue-svg-gauge
      :start-angle="-110"
      :end-angle="110"
      :value="indicadorPjeActual"
      :separator-step="parseInt(indicadorPjeObjetivo)"
      :min="indicadorMin"
      :max="indicadorMax"
      :gauge-color="indicadorColor"
      :scale-interval="1"/>
    <div class="dashboard-chart-text">
      <p>Propuestas: {{ indicadorTotalPresupuestos }}</p>
      <p>Confirmadas: {{ indicadorPresupuestosPropuestosConfirmados }}</p>
      <p>Pje Actual: {{ indicadorPjeActual | numero(2, true) }} %</p>
      <p class="description">{{ indicadorPeriodo }}</p>
      <p class="description">{{ indicadorDescripcion }}</p>
    </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';

export default {
  components: {
    VueSvgGauge,
  },
  props: {
    presupuestosConfirmados: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      indicadorPjeObjetivo: 0,
      indicadorPjeActual: 0,
      indicadorColor: [{ offset: 0, color: '#41B883'}, { offset: 100, color: '#41B883' }],
      indicadorMin: 0,
      indicadorMax: 100,
      indicadorTotalPresupuestos: 0,
      indicadorPresupuestosPropuestosConfirmados: 0,
      indicadorPeriodo: '',
      indicadorDescripcion: ''
    }
  },
  methods: {
    getIndicador() {
      this.$store.dispatch('resultadosPresupuestos/getIndicadorPresupuestosConfirmadosPropuestos')
        .then(() => {
          let indicador = this.$store.getters['resultadosPresupuestos/indicadorPresupuestosConfirmadosPropuestos']

          this.indicadorTotalPresupuestos = indicador.totalPresupuestos;
          this.indicadorPresupuestosPropuestosConfirmados = indicador.presupuestosConfirmados;
          this.indicadorPjeObjetivo = parseFloat(indicador.pjeObjetivo);
          this.indicadorPjeActual = parseFloat(indicador.pjeActual);
          this.indicadorPeriodo = indicador.indicadorPeriodo? indicador.indicadorPeriodo.trim() : '';
          this.indicadorDescripcion = indicador.descripcion? indicador.descripcion.trim() : '';
        })
        .finally(() => this.key++);
    },
  }
}
</script>

<style>
</style>


